import { render, staticRenderFns } from "./UsarCasco.vue?vue&type=template&id=040c7a79&scoped=true&"
import script from "./UsarCasco.vue?vue&type=script&lang=js&"
export * from "./UsarCasco.vue?vue&type=script&lang=js&"
import style0 from "./UsarCasco.vue?vue&type=style&index=0&id=040c7a79&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c7a79",
  null
  
)

export default component.exports